import { removeHtmlTags } from '../../utils/removeHtmlTags';

/**
 * Organiser detail resolver.
 * This pure function annotates organiser detail objects with computed values, e.g. formatted dates.
 */
const resolver = (organiser) =>
  organiser && {
    ...organiser,
    description:
      (organiser.description && removeHtmlTags(organiser.description)) || null,
    permalink: `/o/${organiser.slug}-${organiser.id}`,
    canonical: `${WEB_ROOT}/o/${organiser.slug}-${organiser.id}`,
  };

export default resolver;
